import axios from "axios";

// Central API layer. To later point the landing page at the HEARD app backend,
// change only REACT_APP_BACKEND_URL (or this base) — the signup flow stays the same.
export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// payload: { first_name, last_name, email, device, heard_from, founding_member }
export const submitBetaSignup = (payload) =>
  axios.post(`${API_BASE}/beta-signup`, payload).then((r) => r.data);

export const submitContact = (payload) =>
  axios.post(`${API_BASE}/contact`, payload).then((r) => r.data);

export const getWaitlistStats = () =>
  axios.get(`${API_BASE}/waitlist/stats`).then((r) => r.data);
